import { create } from "zustand";
import { LatLngTuple } from "leaflet";

export interface User {
    userName: string,
    accuracy: number,

    version: string,
    id: string, 
    email: string,
    verificationCode: string, 
    // password
    // isTempPassword
    firstName: string,
    middleName: string,
    lastName: string,
    role: string, 
    phoneNumber: string, 
    workPhone: string, 
    extension: string,
    driverLicense: string, 
    ssn: string, 
    birthDay: string, 
    hireDate: string, 
    quitDate: string, 
    residence: string, 
    residenceState: string, 
    street: string, 
    zipCode: string, 
    address: string, 
    background: string,
    personel: "" | "edit"| "view"| "no", 
    office: "" | "yes"| "no", 
    allOffice: "" | "edit"| "view"| "no", 
    userTheme: string,
    profileUrl: string, // profileId
    // defaultSignId
    coords: LatLngTuple,
    creatorId: string, 
    updaterId: string, 
    dateCreated: string, 
    dateUpdated: string, 
    creator?: string,
    updater?: string,
    creatorEmail: string,
    updaterEmail: string, 
    creatorName?: string, 
    updaterName?: string, 
    void: "yes" | "no",
    voidReason: string,
    validateReason: string,
}


interface AuthStore {
    isAuthenticated: boolean,
    isAuthChecked: boolean, 
    user: Partial<User> | null,

    setUserInfo:(obj: Partial<User>) => void,
    setAuthenticated: (bool: boolean) => void,
    setAuthChecked: (bool: boolean) => void,
    logout: () => void, 
    reset: () => void,
    // token: string | null,
    // setToken: (token: string | null) => void,
    // clearToken: () => void,

}

export const useAuthStore = create<AuthStore>((set, get) => ({
    isAuthenticated: false,
    isAuthChecked: false,
    user: { coords: [37.6148754, -122.0874473] as LatLngTuple, accuracy: 0 }, 

    setUserInfo: (obj) => set(state => state.user?{user: {...state.user, ...obj}}:{user: obj}), 
    setAuthenticated: (bool) => set({isAuthenticated: bool}),  
    setAuthChecked: (bool) => set({isAuthChecked: bool}),  
    // token: null,x
    // setToken: (token) => set({ token }),
    // clearToken: () => set({ token: null }),
    logout: () => {
        set({
            isAuthenticated: false,
            isAuthChecked: true,
            user: null,
        });
    },
    reset: () => {
        set({
            isAuthenticated: false,
            isAuthChecked: true,
            // user: null,
        });
    }
}));
